/**
 * Page Builder Mix Match Slider
 * 
 * Ein Slider der Produkte darstellt
 * 
 * @since     1.0.0
 * @package   pagebuilder
 */
 PageBuilder.MixMatchSlider = (function(PageBuilder) { 

  var _hideOverlaysTrigger; 


  /**
   * Init module. 
   * 
   * Initialisiert das Modul nachdem der DOM geladen wurde.
   * 
   * @since     1.0.0
   * @access    private 
   */
  function _init() { 

    if( $('.mix_match_items_container')[0] ) {
      $('.slickmix').slick({
        speed: 500,
        lazyLoad: 'progressive'
      });
    
      $(document).on('click', '.btn-mm-wk', function(e){
       
        $("#fa-spinner-holder").addClass("active");    
   
        var items = [];
   
        $(this).parents(".mix_match_items_container").find(".mm-slick-item.slick-active").each(function( i, v ) {
          var tmp_item = {};
          tmp_item.dtid = $(v).attr("data-dtid");
          tmp_item.artnr = $(v).attr("data-artnr");
          items.push(tmp_item);
        })
       
        var data = {
          "action": 'shoplook',
          "location" : "mix_match_slider",
          "items"  : items
        };
   
        $.ajax({
          method:   'POST',
          dataType: 'json',
          data:     data
        }).then( function( response ){
          
          var modal = $("#mod-product-shopalook-content"); 
  
          $("#mod-product-shopalook-content").attr("data-location", "mix_match_slider");

          modal.html("");
          modal.html( response.data.template  );
        
          $("#fa-spinner-holder").removeClass("active");
  
          $(".selectpicker").selectpicker("refresh");
          // Modal anzeigen
          $("#mod-product-shopalook").modal("show");
          
        });        
      });
    
      $('.product-action .mk-off').on('click', function(){

        $(this).parents(".product-action").find(".mk-on").toggle();
        $(this).parents(".product-action").find(".mk-off").toggle();
        
        var itemData = {};

        var change_element = $(this).parents(".mm-slick-item.slick-active");

        var mm_artnr = change_element.attr("data-artnr");
        var mm_dtid = change_element.attr("data-dtid");
        
        var mzCount = parseInt($(".aj_mz_art_az").html());

        itemData["aktion"] = "addProduct";
        itemData["artikel[dtid]"] = mm_dtid;
        itemData["artikel[artnr]"] = mm_artnr;
        itemData["artikel[save]"] = true;
        itemData["wishlistAction"] = "addProduct";
        itemData["location"] = "detailList";
  
        $.ajax({
          method:   'POST',
          dataType: 'json',
          data:     itemData 
        }).then( function( response ){

          change_element.attr("data-mk-pos", mzCount );
          mzCount++;

          $('.aj_mz_art_az').text( mzCount );
          var modal = $('#mod-wk-mixmatch');
          modal.find('#mm-wk-default').html("");
          modal.find('#mm-wk-default').html( response.data.template );
          modal.modal('show');
        });
      });

      $('.product-action .mk-on').on('click', function(){

        var itemData = {};

        var mm_artnr = $(this).parents(".mm-slick-item.slick-active").attr("data-artnr");
        var mm_dtid = $(this).parents(".mm-slick-item.slick-active").attr("data-dtid");
        var mm_mkpos = $(this).parents(".mm-slick-item.slick-active").attr("data-mk-pos");
        
        var mzCount = parseInt($(".aj_mz_art_az").html());

        itemData["artikel[dtid]"] = mm_dtid;
        itemData["artikel[artnr]"] = mm_artnr;
        itemData["artikel[save]"] = true;
        itemData["artikel[wk_pos]"] = mm_mkpos;
        itemData["wishlistAction"] = "delProductAjax";
        itemData["location"] = "detailList";
        itemData["artikel[location]"] = "detailList";
        itemData["artikel[AS_mengeneinheit]"] = 1;
        itemData["artikel[wk_art]"] = 4;

        $.ajax({
          method:   'POST',
          dataType: 'json',
          data:     itemData 
        })

        mzCount--;

        $('.aj_mz_art_az').text( mzCount );
        $(this).parents(".product-action").find(".mk-on").toggle();
        $(this).parents(".product-action").find(".mk-off").toggle();
      
      });
    }

  }

  /**
   * Application Module  
   * 
   * Public Scope des Modules das alle nach außen verfügbaren Variablen & Methoden bereit stellt. 
   * 
   * @since     1.0.0
   * @access    public
   */
  var _self = { 
  }

  // Self-init
  if ( document.readyState === "complete" || ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
    _init(); 
  } else {
    document.addEventListener( "DOMContentLoaded", _init );
  }

  return _self;

})( PageBuilder || {} );